import React, {useState, useEffect, useRef, useCallback} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {APIClient} from '../../utils/APIClient';
import {API_URL} from '../../settings/local_settings';
import {CaretUpDown, MagnifyingGlass} from '@phosphor-icons/react';

export function ClientBreadcrumb({clientId, clientName}) {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [showSwitcher, setShowSwitcher] = useState(false);
    const [clients, setClients] = useState([]);
    const [search, setSearch] = useState('');
    const dropdownRef = useRef(null);
    const triggerRef = useRef(null);

    useEffect(() => {
        if (showSwitcher && clients.length === 0) {
            new APIClient(API_URL + 'agency/clients/active').call('GET').then((data) => {
                if (data && data.status === 'OK' && Array.isArray(data.data)) {
                    setClients(data.data);
                }
            }).catch(() => {});
        }
    }, [showSwitcher, clients.length]);

    useEffect(() => {
        function handleClick(e) {
            if (showSwitcher &&
                dropdownRef.current && !dropdownRef.current.contains(e.target) &&
                triggerRef.current && !triggerRef.current.contains(e.target)) {
                setShowSwitcher(false);
                setSearch('');
            }
        }
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [showSwitcher]);

    const handleSelect = useCallback((id) => {
        setShowSwitcher(false);
        setSearch('');
        navigate(`/client/${id}`);
    }, [navigate]);

    const filtered = search
        ? clients.filter(c => c.name.toLowerCase().includes(search.toLowerCase()))
        : clients;

    return (
        <>
            <Link className="topbar-breadcrumb-item" to="/agency/clients">
                {t('breadcrumb.clients')}
            </Link>
            <span className="topbar-breadcrumb-separator">&rsaquo;</span>
            <button
                ref={triggerRef}
                className="topbar-breadcrumb-item current client-switcher-trigger"
                onClick={() => setShowSwitcher(prev => !prev)}
            >
                {clientName || '...'}
                <CaretUpDown size={14} style={{marginLeft: 4, opacity: 0.5}}/>
            </button>

            {showSwitcher && (
                <div ref={dropdownRef} className="client-switcher-dropdown">
                    <div className="client-switcher-search">
                        <MagnifyingGlass size={14}/>
                        <input
                            type="text"
                            placeholder={t('client_cards.search_placeholder')}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            autoFocus
                        />
                    </div>
                    <div className="client-switcher-list">
                        {filtered.map(c => (
                            <button
                                key={c.id}
                                className={`client-switcher-item${String(c.id) === String(clientId) ? ' active' : ''}`}
                                onClick={() => handleSelect(c.id)}
                            >
                                {c.name}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}
